module.exports = __webpack_public_path__ + "static/media/expandgreen.bf5749a7.svg";